import { Component, Vue } from 'vue-property-decorator';

@Component
export default class TimeService extends Vue {
  getTime = (): Date => new Date();
}
